import { createContext, useContext } from 'react';
import type { AIAssistantStore } from './store';

const AIAssistantContext = createContext<AIAssistantStore | null>(null);

export function useAIAssistantContext() {
	const ctx = useContext(AIAssistantContext);
	if (!ctx) {
		throw new Error(
			'useAIAssistantContext must be used within a AIAssistantProvider'
		);
	}
	return ctx;
}

export { AIAssistantContext };
